/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RetireJsonWebKeySecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type RetireJsonWebKeyRequest = {
  /**
   * The ID of the key to retire.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type RetireJsonWebKeySecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RetireJsonWebKeySecurity$outboundSchema: z.ZodMiniType<
  RetireJsonWebKeySecurity$Outbound,
  RetireJsonWebKeySecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function retireJsonWebKeySecurityToJSON(
  retireJsonWebKeySecurity: RetireJsonWebKeySecurity,
): string {
  return JSON.stringify(
    RetireJsonWebKeySecurity$outboundSchema.parse(retireJsonWebKeySecurity),
  );
}

/** @internal */
export type RetireJsonWebKeyRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const RetireJsonWebKeyRequest$outboundSchema: z.ZodMiniType<
  RetireJsonWebKeyRequest$Outbound,
  RetireJsonWebKeyRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function retireJsonWebKeyRequestToJSON(
  retireJsonWebKeyRequest: RetireJsonWebKeyRequest,
): string {
  return JSON.stringify(
    RetireJsonWebKeyRequest$outboundSchema.parse(retireJsonWebKeyRequest),
  );
}
